
  /* V8 W12（只 g5b）：(1) 釉色小圖點擊換卡上的照片，不跳頁；再點一次還原。(2) 加購按鈕鍵盤 Enter／空白鍵。(3) L9：同一列的卡，只要有一張價錢區換行，整列一起換行。 */
  (function () {
    if (window.__csV8Card) { return; }
    window.__csV8Card = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.cs-v8-glaze__btn') : null;
      if (!b) { return; }
      e.preventDefault(); e.stopPropagation();
      var card = b.closest('.card-wrapper');
      var img = card && (card.querySelector('.card__media picture img') || card.querySelector('.card__media img'));
      if (!img) { return; }
      var pic = img.closest('picture');
      var srcs = pic ? pic.querySelectorAll('source') : [];
      if (!img.hasAttribute('data-cs-orig-src')) {
        img.setAttribute('data-cs-orig-src', img.getAttribute('src') || '');
        img.setAttribute('data-cs-orig-srcset', img.getAttribute('srcset') || '');
        Array.prototype.forEach.call(srcs, function (s) { s.setAttribute('data-cs-orig-media', s.getAttribute('media') || ''); });
      }
      var group = b.parentNode;
      var was = b.getAttribute('aria-pressed') === 'true';
      Array.prototype.forEach.call(group.querySelectorAll('.cs-v8-glaze__btn'), function (x) { x.setAttribute('aria-pressed', 'false'); });
      if (was) {
        img.setAttribute('srcset', img.getAttribute('data-cs-orig-srcset'));
        img.setAttribute('src', img.getAttribute('data-cs-orig-src'));
        Array.prototype.forEach.call(srcs, function (s) { var m = s.getAttribute('data-cs-orig-media'); if (m) { s.setAttribute('media', m); } else { s.removeAttribute('media'); } });
        card.removeAttribute('data-cs-glaze-on');
      } else {
        Array.prototype.forEach.call(srcs, function (s) { s.setAttribute('media', 'not all'); });
        img.setAttribute('srcset', b.getAttribute('data-cs-srcset'));
        img.setAttribute('src', b.getAttribute('data-cs-src'));
        b.setAttribute('aria-pressed', 'true');
        card.setAttribute('data-cs-glaze-on', b.getAttribute('aria-label') || '');
      }
    }, true);
    var spaceDown = null;
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (!(t && t.hasAttribute && t.hasAttribute('data-cs-v8-btn'))) { return; }
      if (e.key === 'Enter') { e.preventDefault(); if (!e.repeat) { t.click(); } }
      else if (e.key === ' ') { e.preventDefault(); if (!e.repeat) { spaceDown = t; } }
    });
    document.addEventListener('keyup', function (e) {
      var t = e.target;
      if (e.key !== ' ' || !(t && t.hasAttribute && t.hasAttribute('data-cs-v8-btn'))) { return; }
      e.preventDefault();
      if (spaceDown === t) { spaceDown = null; t.click(); }
    });
    var MQ = window.matchMedia('(min-width: 750px)');
    function lv(w) {
      var pe = w.querySelector('.cs-v6-price-row .price');
      if (!pe) { return 1; }
      var sale = w.querySelector('.cs-v6-price-row .price-item--sale') || w.querySelector('.cs-v6-price-row .price-item');
      var top = (sale || pe).getBoundingClientRect().top;
      var out = 1;
      var bd = w.querySelector('.cs-v6-badge-d');
      if (bd && bd.getBoundingClientRect().top - top > 6) { out = 2; }
      var rg = w.querySelector('.cs-v6-price-row s.price-item--regular');
      if (rg && rg.getBoundingClientRect().top - top > 6) { out = 3; }
      return out;
    }
    function balance() {
      var grids = document.querySelectorAll('ul.product-grid');
      Array.prototype.forEach.call(grids, function (g) {
        var ws = g.querySelectorAll('.cs-v8-card');
        Array.prototype.forEach.call(ws, function (w) { w.removeAttribute('data-cs-wrap'); });
        return; /* V11 批 1 A9：價錢改單行 flex wrap，不再整列一起換行；保留上面的 removeAttribute 讓舊標記清掉 */
        var rows = {};
        Array.prototype.forEach.call(ws, function (w) {
          var li = w.closest('li') || w;
          var k = Math.round(li.getBoundingClientRect().top / 4);
          var l = lv(w);
          (rows[k] = rows[k] || { max: 1, ws: [] });
          rows[k].ws.push(w); if (l > rows[k].max) { rows[k].max = l; }
        });
        Object.keys(rows).forEach(function (k) {
          if (rows[k].max > 1) { rows[k].ws.forEach(function (w) { w.setAttribute('data-cs-wrap', String(rows[k].max)); }); }
        });
      });
    }
    var raf = 0;
    function later() { if (raf) { return; } raf = requestAnimationFrame(function () { raf = 0; balance(); }); }
    window.addEventListener('resize', later);
    window.addEventListener('load', later);
    if (MQ.addEventListener) { MQ.addEventListener('change', later); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(later); }
    if (window.MutationObserver) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) { if (ms[i].addedNodes && ms[i].addedNodes.length) { later(); return; } }
      }).observe(document.body, { childList: true, subtree: true });
    }
    later();
  })();

/* V10-W2 X3（只 g5b）：種類格桌面左右箭頭。一次捲約 86% 的寬度，到頭就停用箭頭；不需要捲動（格子放得下）時兩顆箭頭都停用。 */
(function () {
  if (window.__csX3) { return; }
  window.__csX3 = 1;
  function sync(w) {
    var r = w.querySelector('.cs-x3__rail'), p = w.querySelector('[data-cs-x3-dir="-1"]'), n = w.querySelector('[data-cs-x3-dir="1"]');
    if (!r || !p || !n) { return; }
    p.disabled = r.scrollLeft <= 1;
    n.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 1;
    p.hidden = n.hidden = r.scrollWidth <= r.clientWidth + 1;
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cs-x3]'), function (w) {
      var r = w.querySelector('.cs-x3__rail');
      if (!r) { return; }
      if (w.getAttribute('data-cs-x3-bound')) { sync(w); return; }
      w.setAttribute('data-cs-x3-bound', '1');
      r.addEventListener('scroll', function () { sync(w); }, { passive: true });
      sync(w);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-cs-x3-dir]') : null;
    if (!b) { return; }
    var w = b.closest('[data-cs-x3]'), r = w && w.querySelector('.cs-x3__rail');
    if (!r) { return; }
    r.scrollBy({ left: parseInt(b.getAttribute('data-cs-x3-dir'), 10) * r.clientWidth * 0.86, behavior: 'smooth' });
  });
  /* V12-7：桌面滑鼠拖曳（超過 5px 才算拖曳，放開時攔下那次 click，不誤開連結；沒拖曳的 click 照常）與 Shift＋滾輪（deltaY 轉成橫向）。
     觸控板橫向捲動、觸控滑動是 overflow-x 原生行為，不需要處理。只在 rail 真的可以橫捲時動作（手機是 2 欄 grid，不可捲，直接略過）。 */
  var drag = null, swallow = false;
  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0 || !e.target || !e.target.closest) { return; }
    var r = e.target.closest('.cs-x3__rail');
    if (!r || r.scrollWidth <= r.clientWidth + 1) { return; }
    drag = { r: r, x: e.clientX, left: r.scrollLeft, moved: false };
  });
  document.addEventListener('mousemove', function (e) {
    if (!drag) { return; }
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) { drag.moved = true; drag.r.classList.add('is-drag'); }
    if (drag.moved) { drag.r.scrollLeft = drag.left - dx; e.preventDefault(); }
  });
  function endDrag() {
    if (!drag) { return; }
    var moved = drag.moved;
    drag.r.classList.remove('is-drag');
    drag = null;
    if (moved) { swallow = true; setTimeout(function () { swallow = false; }, 0); }
  }
  document.addEventListener('mouseup', endDrag);
  window.addEventListener('blur', endDrag);
  document.addEventListener('click', function (e) {
    if (swallow && e.target && e.target.closest && e.target.closest('.cs-x3__rail')) { e.preventDefault(); e.stopPropagation(); swallow = false; }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.closest && e.target.closest('.cs-x3__rail')) { e.preventDefault(); }
  });
  document.addEventListener('wheel', function (e) {
    if (!e.shiftKey || !e.target || !e.target.closest) { return; }
    var r = e.target.closest('.cs-x3__rail');
    if (!r || r.scrollWidth <= r.clientWidth + 1) { return; }
    var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    if (!d) { return; }
    e.preventDefault();
    r.scrollLeft += d;
  }, { passive: false });
  window.addEventListener('resize', init);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  /* V10-W2 X5：手機新品列的進度條，寬度＝可見比例，位置＝捲動比例。 */
  function prog(row) {
    var r = row.querySelector('.product-grid'), b = row.querySelector('[data-cs-x5-prog] i');
    if (!r || !b) { return; }
    var max = r.scrollWidth - r.clientWidth, w = max > 0 ? Math.max(12, r.clientWidth / r.scrollWidth * 100) : 100;
    b.style.width = w + '%';
    b.style.left = (max > 0 ? (r.scrollLeft / max) * (100 - w) : 0) + '%';
  }
  function initProg() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cs-np2]'), function (row) {
      var r = row.querySelector('.product-grid');
      if (!r || row.getAttribute('data-cs-x5-bound')) { return; }
      row.setAttribute('data-cs-x5-bound', '1');
      r.addEventListener('scroll', function () { prog(row); }, { passive: true });
      prog(row);
    });
  }
  window.addEventListener('resize', function () { Array.prototype.forEach.call(document.querySelectorAll('[data-cs-np2]'), prog); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initProg); } else { initProg(); }
  window.addEventListener('load', initProg);
})();
